import { h } from 'vue';
import Tag from 'primevue/tag';

export const getRoleSeverity = (role) => {
    switch (role?.toLowerCase()) {
        case 'superadmin':
            return 'danger';
        case 'admin':
            return 'danger';
        case 'finance':
            return 'primary';
        case 'affiliate':
            return 'info';
        case 'user':
            return 'secondary';
        default:
            return 'secondary';
    }
};

export const getRoleName = (roles) => {
    if (!roles || !roles.length) return null;
    let mainRole = roles[0];

    if(roles.length !== 1){
        //finance       
        if(roles.includes('superadmin')){
            mainRole = 'superadmin';
        }
        else if(roles.includes('finance')){
            mainRole = 'finance';
        }
        else if(roles.includes('admin')){
            mainRole = 'admin';
        }
        else if(roles.includes('subaffiliate')){
            mainRole = 'subaffiliate';
        }
    }

    if(mainRole === 'user'){
        mainRole = 'publisher';
    }
    return mainRole;
}
export const getRoleTag = (roles) => {
    const mainRole = getRoleName(roles);
    return h(Tag, {
        value: mainRole,
        severity: getRoleSeverity(mainRole)
    });
};